import { inject } from '@angular/core';
import type { ResolveFn } from '@angular/router';
import { FraudWarningsService } from '../services/fraud-warnings.service';

export const fraudWarningsResolver: ResolveFn<boolean> = async (route, state) => {
  const service = inject(FraudWarningsService);

  try {
    await service.list();
    return true;
  } catch (error) {
    console.warn('Error loading fraud warnings:', error);
    return false;
  }
};
